import React, { useState, useEffect } from 'react';
import './Diwasa.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt, faLeaf, faGlobe, faCheckCircle, faDatabase } from '@fortawesome/free-solid-svg-icons';
import { faMap } from '@fortawesome/free-solid-svg-icons'; // Updated icon

import { Link } from 'react-router-dom';
import Footer from "../components/Footer";
// ✅ Multiple images
import img1 from '../images/img2.jpg';
import img2 from '../images/img3.jpg';
import img3 from '../images/img4.jpg';

const imageList = [img1, img2, img3];

const Diwasa= () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % imageList.length
      );
    }, 3000); // ⏱ Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const handleExplore = () => {
    window.open('https://www.iwmi.org/projects/diwasa/', '_blank');
  };

  return (
    <section className="about-section">
      {/* Top section with image and text */}
      <div className="about-top">
        <div className="about-image">
          <img src={imageList[currentImageIndex]} alt="DIWASA Overview" />
        </div>
        <div className="about-text">
        
           <h1>
            What is <span>DIWASA ?</span>
          </h1>
          <p>
            <strong>IWMI's Digital Innovations for a Water Secure Africa (DIWASA)</strong> initiative is committed to leveraging digital innovations such as remote sensing, cloud computing, open data initiatives and eventually, machine learning to enhance the accessibility of water data throughout the African continent. The primary emphasis of DIWASA lies in Water Accounting and Resilience applications which encompass a diverse range of products tailored to various scales. These DIWASA products will be progressively disseminated through Digital Earth Africa and the Africa Geoportal.  

          </p>
          <p>DIWASA has been developed in partnership with the Digital Earth Africa with the generous support of the Leona M. and Harry B. Helmsley Charitable Trust. </p>
          <p>This dashboard consists of three major components: 

 </p>
          <ul className="about-list">
            <li><FontAwesomeIcon icon={faCheckCircle} />Portfolio Explorer.</li>
            <li><FontAwesomeIcon icon={faCheckCircle} /> Resources</li>
            <li><FontAwesomeIcon icon={faCheckCircle} /> Request Data Access</li>
          </ul>
         
        </div>
      </div>

    <div className="about-features">
  <Link to="/map" className="feature-card-link">
    <div className="feature-card" style={{ backgroundColor: '#0297A6' }}>
      <FontAwesomeIcon icon={faMap} size="2x" />
      <h3>Portfolio Explorer</h3>
      <p>
        The IWMI DIWASA portfolio explorer offers a comprehensive and interactive platform
        that showcases IWMI DIWASA's research activities and water data for various countries in Africa.
           This platform is designed to address the persistent challenge of water data fragmentation across Africa.
      </p>
     
    </div>
  </Link>


        <div className="feature-card" style={{ backgroundColor: '#E86933' }}>
          <FontAwesomeIcon icon={faLeaf} size="2x" />
          <h3>Resources</h3>
          <p>The resources page provides information on water data products, publications, blogs, and other resources. .</p>
        </div>
        <Link to="/requestdataaccess" className="feature-card-link">
        <div className="feature-card" style={{ backgroundColor: '#DD9103' }}>
          <FontAwesomeIcon icon={faDatabase} size="2x" />
          <h3>Request Data Access</h3>
          <p>This page provides user to request access to water foundational data and products for different countries across Africa.   

 </p>
 
        </div>
       </Link>
      </div>
      

      {/* Call to action button */}
      <div className="about-button button">
      
        <button onClick={handleExplore}>Explore DIWASA</button>
          
      </div>
    <div>
       <Footer />    
    </div>
    </section>
    
    
  );
};

export default Diwasa;
